/*
 * Keeps the media gallery in sync with the Pumper Bundles variant picker.
 *
 * Pumper hides the theme's variant picker (hideThemeVariants) and swaps the
 * product form's hidden `input[name="id"]` directly when the shopper picks a
 * colour in its widget. It dispatches none of the theme's variant events —
 * verified live: no variant:update, no pumper:v2:variant-picker:changed,
 * nothing reaches the document — so <media-gallery> never re-renders and the
 * gallery keeps showing the previous variant's featured image.
 *
 * Pumper does write the input's `value` attribute (not just the property), so
 * an attribute MutationObserver is a reliable, dependency-free signal. On
 * change we fetch the section rendered for the new variant and replace the
 * gallery wholesale — the same thing the theme's own #handleVariantUpdate does
 * (`this.replaceWith(newMediaGallery)`), which is also the only correct move
 * in hide_variants mode where the gallery's DOM differs per variant.
 *
 * Inactive unless a Pumper widget is on the page and the theme's own variant
 * picker is hidden — on ordinary products the theme picker drives the gallery
 * itself and this script must not double-render.
 */
(() => {
  if (window.__bbPumperVariantBridge) return;
  window.__bbPumperVariantBridge = true;

  const init = () => {
    const input = document.querySelector('product-form-component input[name="id"]');
    const section = input?.closest(".shopify-section");
    if (!input || !section) return;

    const sectionId = section.id.replace(/^shopify-section-/, "");
    let last = input.value;
    let ctrl = null;

    const pumperDrivesThePicker = () => {
      const widget = document.querySelector("#pumper_bundle_svelte, .pumper-bundles");
      if (!widget || !widget.offsetParent) return false;
      const themePicker = document.querySelector("variant-picker, .variant-picker-block");
      return !themePicker || themePicker.offsetHeight === 0;
    };

    const refresh = async (variantId) => {
      ctrl?.abort();
      ctrl = new AbortController();
      const url = `${location.pathname}?variant=${variantId}&section_id=${sectionId}`;
      try {
        const res = await fetch(url, { signal: ctrl.signal });
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), "text/html");
        const fresh = doc.querySelector("media-gallery");
        const current = document.querySelector("media-gallery");
        if (fresh && current) current.replaceWith(fresh);
      } catch (err) {
        if (err?.name !== "AbortError") console.error("[pumper-variant-bridge]", err);
      }
    };

    new MutationObserver(() => {
      const v = input.getAttribute("value");
      if (!v || v === last) return;
      last = v;
      if (pumperDrivesThePicker()) refresh(v);
    }).observe(input, { attributes: true, attributeFilter: ["value"] });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
